import { defineComponent as s, onBeforeMount as t, createBlock as o, openBlock as n, unref as a, withCtx as r, createVNode as p } from "vue";
import { addScalarClassesToHeadless as l, ScalarModal as y } from "@scalar/components";
import c from "./TypesenseSearch.vue.js";
const C = /* @__PURE__ */ s({
  __name: "Search",
  props: {
    modalState: {},
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  setup(i) {
    return t(() => l()), (e, m) => (n(), o(a(y), {
      "aria-label": "Reference Search",
      state: e.modalState,
      variant: "search"
    }, {
      default: r(() => [
        p(c, {
          typesenseCollection: e.typesenseCollection,
          typesenseHost: e.typesenseHost,
          typesenseKey: e.typesenseKey
        }, null, 8, ["typesenseCollection", "typesenseHost", "typesenseKey"])
      ]),
      _: 1
    }, 8, ["state"]));
  }
});
export {
  C as default
};
